<template>
  <div>
    <v-row>
      <v-col
        cols="12"
      >
        <liquidity-risk-assessment />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
      >
        <real-time-monitoring />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
      >
        <key-liquidity-ratios />
      </v-col>
    </v-row>
  </div>
</template>

    <script>
import i18nRouteMeta                     from '@/mixins/i18n/i18nRouteMeta'
import API from '@/api/Api'
import LiquidityRiskAssessment from '@/theme/default/views/banking/risk/liquidity/risk-monitoring/liquidity-risk-assessment/LiquidityRiskAssessment.vue'
import KeyLiquidityRatios from '@/theme/default/views/banking/risk/liquidity/risk-monitoring/key-liquidity-ratios/KeyLiquidityRatios.vue'
import RealTimeMonitoring from '@/theme/default/views/banking/risk/liquidity/risk-monitoring/real-time-monitoring/RealTimeMonitoring.vue'

export default {
  name      : 'RiskMonitoring',
  components: {
    LiquidityRiskAssessment,
    KeyLiquidityRatios,
    RealTimeMonitoring
  },
  mixins: [i18nRouteMeta],
  props : {
    selectedDate: {
      type   : String,
      default: ''
    }
  },
  dataStore: {
    appToolbarExtended          : 'App.Config.AppToolbarExtended',
    monitoringLiquidity         : 'RiskLiquidity.MonitoringLiquidity',
    socialMediaMentions         : 'RiskLiquidity.SocialMediaMentions',
    currentLiquidityParametersId: 'ActiveLiquidityParameters.currentLiquidityParametersId'
  },
  data () {
    return {
      breakpoint    : (this.appToolbarExtended && this.$vuetify.breakpoint.smAndDown ? 12 : 6),
      minBlockHeight: 364
    }
  },
  computed: {
    breadcrumb () {
      return [{
        text    : this.$t('ALM.HeaderTitle'),
        disabled: true
      }]
    },
    accountId () {
      return this.user?.selectedAccountId || null
    }
  },
  watch: {
    appToolbarExtended (val) {
      this.breakpoint = val && this.$vuetify.breakpoint.smAndDown ? 12 : 6
    },

    '$vuetify.breakpoint.smAndDown': {
      handler (val) {
        this.breakpoint = val && this.appToolbarExtended ? 12 : 6
      }
    }
  },
  created () {
    this.getMonitoringLiquidity()
    this.$bus.$on('liquidity:cancel-assumptions-edit', this.getMonitoringLiquidity)
  },
  beforeDestroy () {
    this.$bus.$off('liquidity:cancel-assumptions-edit', this.getMonitoringLiquidity)
  },
  methods: {
    async getMonitoringLiquidity () {
      const response = await API.Resource.RiskLiquidity.GetMonitoringLiquidity(this.accountId, this.currentLiquidityParametersId)
      this.handleResponse(response, 'monitoringLiquidity')
    },

    handleResponse (response, key) {
      const data = API.responseData(response)?.[key] || null

      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        this[key].Data = data
      } else {
        this.$bus.$emit('app:error', errors)
      }
    }
  }
}
    </script>

    <style scoped>
    </style>
